import React, { useEffect, useRef } from "react";
import { Sidebar } from "react-pro-sidebar";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  useTheme,
} from "@mui/material";
import { Link, useLocation, NavLink } from "react-router-dom";
import "../doctor/components.css";
import logos from "../../assets/images/mainlogo.svg";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import { LocationOnOutlined, CardMembership } from "@mui/icons-material";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function AdminSidebar({ isOpen }) {
  const theme = useTheme();
  const location = useLocation();
  const accordionRef = useRef(null);

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleClickOutside = (event) => {
    if (accordionRef.current && !accordionRef.current.contains(event.target)) {
      setExpanded(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Sidebar className="sidebar">
      <div className="mainlogo">
        <img src={logos} alt="logo" />
      </div>

      <div className="navigationMenu">
        <nav id="sidebar" className="accordianmenu">
          <List>
            <ListItem
              button
              component={NavLink}
              to="/admin/dashboard"
              selected={location.pathname === "/admin/dashboard"}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  marginRight: theme.spacing(1),
                  display: "flex",
                  alignItems: "center",
                  marginRight: "16px",
                }}
              >
                <DashboardOutlinedIcon
                  sx={{ fontSize: 30 }}
                  titleAccess="Dashboard"
                />
              </ListItemIcon>
              <ListItemText
                primary="Dashboard"
                sx={{
                  marginLeft: 0,
                  ".MuiTypography-root": {
                    fontSize: "15px",
                    padding: 0,
                    margin: 0,
                  },
                }}
              />
            </ListItem>

            <Accordion
              ref={accordionRef}
              className="menuItems"
              expanded={expanded === "panel1"}
              onChange={handleChange("panel1")}
              defaultExpanded
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <NavLink
                  className="sideNavigation"
                  to="/admin/dashboard/manage-leads"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                  >
                    <path
                      d="M19 7.42749H10M19 12.4275H10M19 17.4275H10M7 7.42749C7 7.97977 6.55228 8.42749 6 8.42749C5.44772 8.42749 5 7.97977 5 7.42749C5 6.87521 5.44772 6.42749 6 6.42749C6.55228 6.42749 7 6.87521 7 7.42749ZM7 12.4275C7 12.9798 6.55228 13.4275 6 13.4275C5.44772 13.4275 5 12.9798 5 12.4275C5 11.8752 5.44772 11.4275 6 11.4275C6.55228 11.4275 7 11.8752 7 12.4275ZM7 17.4275C7 17.9798 6.55228 18.4275 6 18.4275C5.44772 18.4275 5 17.9798 5 17.4275C5 16.8752 5.44772 16.4275 6 16.4275C6.55228 16.4275 7 16.8752 7 17.4275Z"
                      stroke="black"
                      strokeLinecap="round"
                    />
                  </svg>
                  <span>Leads</span>
                </NavLink>
              </AccordionSummary>
              <AccordionDetails>
                <NavLink
                  className="sideNavigation"
                  to="/admin/dashboard/manage-leads"
                >
                  <span>List View</span>
                </NavLink>
                <NavLink
                  className="sideNavigation"
                  to="/admin/dashboard/pipeline-view"
                >
                  <span>Pipeline View</span>
                </NavLink>
              </AccordionDetails>
            </Accordion>
            <Accordion
              className="menuItems"
              expanded={expanded === "panel2"}
              onChange={handleChange("panel2")}
            >
              <AccordionSummary
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <NavLink
                  className="sideNavigation"
                  to={`/admin/dashboard/reviewsection`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="25"
                    viewBox="0 0 21 25"
                    fill="none"
                  >
                    <path
                      d="M2.03538 12.9275L1.67217 13.1512C1.26478 13.4022 0.771512 12.9926 0.943272 12.546L1.45072 11.2267C1.53198 11.0154 1.46117 10.7759 1.27809 10.6428L0.244022 9.89088C-0.147648 9.60608 0.0538017 8.98648 0.538072 8.98648H1.66881C1.88701 8.98648 2.08001 8.84497 2.14565 8.63687L2.52336 7.43932C2.67038 6.97319 3.33003 6.97319 3.47705 7.43932L3.85476 8.63687C3.92039 8.84497 4.1134 8.98648 4.3316 8.98648H5.26229C5.7642 8.98648 5.95317 9.64331 5.528 9.91003L5.5002 9.92747M12.5002 9.92747L12.4724 9.91003C12.0472 9.64331 12.2362 8.98648 12.7381 8.98648H13.6688C13.887 8.98648 14.08 8.84497 14.1456 8.63687L14.5234 7.43932C14.6704 6.97319 15.33 6.97319 15.477 7.43932L15.8548 8.63687C15.9204 8.84497 16.1134 8.98648 16.3316 8.98648H17.4623C17.9466 8.98648 18.1481 9.60608 17.7564 9.89087L16.7223 10.6428C16.5392 10.7759 16.4684 11.0154 16.5497 11.2267L17.0571 12.546C17.2289 12.9926 16.7356 13.4022 16.3282 13.1512L15.965 12.9275M11.3933 16.0554L11.9718 17.5593C12.24 18.2567 11.4349 18.8746 10.8306 18.4351L9.5884 17.5316C9.2377 17.2766 8.7627 17.2766 8.412 17.5316L7.1698 18.4351C6.56551 18.8746 5.76041 18.2567 6.02864 17.5593L6.60709 16.0554C6.76961 15.6329 6.62799 15.1538 6.26184 14.8876L4.86593 13.8726C4.27842 13.4454 4.5806 12.516 5.307 12.516H6.81982C7.2562 12.516 7.6422 12.233 7.7735 11.8168L8.2849 10.1952C8.5055 9.49605 9.4949 9.49605 9.7155 10.1952L10.2269 11.8168C10.3582 12.233 10.7442 12.516 11.1806 12.516H12.6934C13.4198 12.516 13.722 13.4454 13.1345 13.8726L11.7386 14.8876C11.3724 15.1538 11.2308 15.6329 11.3933 16.0554Z"
                      stroke="#3D3E3F"
                      strokeWidth="0.9"
                      strokeLinecap="round"
                    />
                  </svg>
                  <span>Review</span>
                </NavLink>
              </AccordionSummary>
            </Accordion>

            <ListItem
              button
              component={NavLink}
              to="/admin/dashboard/manage-providers"
              selected={
                location.pathname === "/admin/dashboard/manage-providers"
              }
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  marginRight: theme.spacing(1),
                  display: "flex",
                  alignItems: "center",
                  marginRight: "16px",
                }}
              >
                <LocationOnOutlined sx={{ fontSize: 30 }} />
              </ListItemIcon>
              <ListItemText
                primary="Manage Locations"
                sx={{
                  marginLeft: 0,
                  ".MuiTypography-root": {
                    fontSize: "15px",
                    padding: 0,
                    margin: 0,
                  },
                }}
              />
            </ListItem>

            <ListItem
              button
              component={NavLink}
              to="/admin/dashboard/typeform-questions"
              selected={
                location.pathname === "/admin/dashboard/typeform-questions"
              }
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  marginRight: theme.spacing(1),
                  display: "flex",
                  alignItems: "center",
                  marginRight: "16px",
                }}
              >
                <BarChartOutlinedIcon sx={{ fontSize: 30 }} />
              </ListItemIcon>
              <ListItemText
                primary="Typeform Questions"
                sx={{
                  marginLeft: 0,
                  ".MuiTypography-root": {
                    fontSize: "15px",
                    padding: 0,
                    margin: 0,
                  },
                }}
              />
            </ListItem>

            <ListItem
              button
              component={NavLink}
              to="/admin/dashboard/cardDetails"
              selected={location.pathname === "/admin/dashboard/cardDetails"}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  marginRight: theme.spacing(1),
                  display: "flex",
                  alignItems: "center",
                  marginRight: "16px",
                }}
              >
                <CardMembership sx={{ fontSize: 30 }} />
              </ListItemIcon>
              <ListItemText
                primary="Transactions"
                sx={{
                  marginLeft: 0,
                  ".MuiTypography-root": {
                    fontSize: "15px",
                    padding: 0,
                    margin: 0,
                  },
                }}
              />
            </ListItem>

            <ListItem
              button
              component={NavLink}
              to="/admin/dashboard/logs"
              selected={location.pathname === "/admin/dashboard/logs"}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  marginRight: theme.spacing(1),
                  display: "flex",
                  alignItems: "center",
                  marginRight: "16px",
                }}
              >
                <SettingsOutlinedIcon sx={{ fontSize: 30 }} />
              </ListItemIcon>
              <ListItemText
                primary="Logs"
                sx={{
                  marginLeft: 0,
                  ".MuiTypography-root": {
                    fontSize: "15px",
                    padding: 0,
                    margin: 0,
                  },
                }}
              />
            </ListItem>
          </List>
        </nav>
      </div>
    </Sidebar>
  );
}
